import { Block } from '../../../../services/entities/impl/blfApi/schemas/block';
import { Scan } from '../../../../services/entities/impl/blfApi/schemas/scan';
import { Stage } from '../../../../services/entities/impl/blfApi/schemas/stage';
import { useDuckQuery } from '../../../duckDB/hooks/useDuckQuery';
import { formatStringList } from '../../../duckDB/utils/formatStringList';
import { StageCount } from '../controls/StageDataDisplay/types';

export const useGetBlockStageCounts = (
  blockId: Block['id'],
  scanId: Scan['id'],
  stageIds: Stage['id'][],
  skip?: boolean
): UseGetBlockStageCountsReturn => {
  // NOTE: The point details view uses the stage_raw_count column, which is the raw count of the stage.
  // We are choosing to use the stage_count column here because it is the column that is used by the reports page,
  // where the user navigated from. So the totals should match.
  const { data, isLoading } = useDuckQuery<{
    stageId: string;
    count: number;
  }>(
    `SELECT
        stage_id as stageId,
        round(sum(stage_count::FLOAT)) AS count
    FROM stage_map_table 
    WHERE scan_id='${scanId}' 
        AND block_id='${blockId}'
        AND stage_id IN ${formatStringList(stageIds)}
    GROUP BY stage_id
    `,
    skip || !blockId || !scanId
  );

  return {
    stageCounts: data ?? [],
    loading: isLoading,
  };
};

type UseGetBlockStageCountsReturn = {
  stageCounts: StageCount[];
  loading: boolean;
};
